"use client";
//#region packages/@mantine/core/src/core/Box/style-props/parse-style-props/sort-media-queries.ts
function replaceMediaQuery(query) {
	return query.replace("(min-width: ", "").replace("em)", "");
}
function sortMediaQueries({ media, ...props }) {
	const sortedMedia = Object.keys(media).sort((a, b) => Number(replaceMediaQuery(a)) - Number(replaceMediaQuery(b))).map((query) => ({
		query,
		styles: media[query]
	}));
	return {
		...props,
		media: sortedMedia
	};
}
//#endregion
export { sortMediaQueries };

//# sourceMappingURL=sort-media-queries.mjs.map